import styled from 'styled-components';
import { mobileThreshold } from '../../../../Constants/layoutValues';
import { cssVarColors } from '../../../../Constants/cssVarColors';

export const LinkColumnWrapper = styled.div`
	flex: 2;
	line-height: 2;
	text-align: right;
	padding-right: 2em;
	@media (max-width: ${mobileThreshold}px) {
		flex: none;
		width: calc(50% - 2em);
		padding-bottom: 1.5em;
		padding-right: 1em;
		padding-left: 1em;
		text-align: center;
	}
`;

export const LinkHeader = styled.div`
	text-transform: uppercase;
	font-weight: bold;
`;

export const LinkItem = styled.div`
	cursor: pointer;
	&:hover {
		color: ${cssVarColors.highlight};
	}
`;

export const LinkItemAnchor = styled('a')`
	cursor: pointer;
	text-decoration: none;
	color: #fff;
	&:hover {
		color: ${cssVarColors.highlight};
	}
`;
